import { useContext } from 'react';

// eslint-disable-next-line import/no-cycle -- TODO: pre-existing cycle via DataModelContext, fix when context is restructured
import { DragAndDropContext } from 'contexts/drag-and-drop/DragAndDropContext';

export const useDragAndDrop = () => {
  const dragAndDropState = useContext(DragAndDropContext);
  return dragAndDropState;
};
